import React from 'react';
import PropTypes from 'prop-types';

import {Box} from 'views/components';

import WeeklySkeleton from './ScheduleSkeleton';
import UserSkeleton from './UserSkeleton';

const LoadingScreen = (props) => {
  const {weekDays} = props;
  return (
    Array.from({length: 5}).map((_, idx) => (
      <Box
        key={idx}
        sx={{
          'display': 'flex',
          'minHeight': 64,
          'borderBottom': '1px solid #ccc',
        }}
      >
        <Box
          sx={{
            'minWidth': 220,
            'borderRight': '1px solid #ccc',
          }}
        >
          <UserSkeleton />
        </Box>
        <WeeklySkeleton weekDays={weekDays} />
      </Box>
    ))
  );
};

LoadingScreen.propTypes = {
  weekDays: PropTypes.arrayOf(PropTypes.object),
};

export default LoadingScreen;
